import { render } from "./WCFavoriteButton.vue?vue&type=template&id=3d070700&scoped=true"
import script from "./WCFavoriteButton.vue?vue&type=script&lang=js"
export * from "./WCFavoriteButton.vue?vue&type=script&lang=js"

import "./WCFavoriteButton.vue?vue&type=style&index=0&id=3d070700&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d070700"]])

export default __exports__